import type { ReactNode } from 'react';
import {
  Popover as MantinePopover,
  PopoverProps as MantinePopoverProps,
  PopoverStylesNames,
} from '@mantine/core';
import clsx from 'clsx';

import styles from './popover.module.scss';

export type PopoverProps = {
  /** Popover target node */
  children: ReactNode;
  /** Popover content node */
  content?: ReactNode;
  disabled?: boolean;
  classNames?: Partial<Record<PopoverStylesNames | 'content', string>>;
} & Pick<MantinePopoverProps, 'position'>;

/**
 * Standard themed Popover component
 */
export const Popover = ({
  children,
  content,
  classNames,
  disabled,
  position = 'bottom-end',
}: PopoverProps) => {
  return (
    <MantinePopover
      arrowOffset={20}
      arrowSize={12}
      offset={4}
      position={position}
      shadow="md"
      withArrow
      disabled={disabled}
      classNames={{
        dropdown: clsx(styles['dropdown'], classNames?.dropdown),
        arrow: clsx(styles['arrow'], classNames?.arrow),
      }}
    >
      <MantinePopover.Target>{children}</MantinePopover.Target>
      <MantinePopover.Dropdown>
        <div className={clsx(styles['content'], classNames?.content)}>
          {content}
        </div>
      </MantinePopover.Dropdown>
    </MantinePopover>
  );
};
